import React from 'react'
import { isMobile } from "react-device-detect";
import "../partials/CSS/ConnectNowInterface.css"

const ConnectNowInterface = () => {
  return (
      <div className={`${!isMobile?"connect-now-container":"connect-now-container-mob"}`}>
          <span>Add </span>
          <span style={{
              color:"#FFD700"
          }}>inferences </span>
          <span>from your </span>
          <span style={{
              color:"#FFD700"
          }}>own models </span>
          <span>!</span>
          <a href='https://tally.so/r/wg5MDK'>
              <div className={`${!isMobile?"connect-now-btn":"connect-now-btn-mob"}`}>
              Connect Now
          </div>
          </a>
          
    </div>
  )
}

export default ConnectNowInterface